import * as React from "react";
import {lazyInject} from "@athena-portal/core";
import {IWithRouterProps, Overlay, withRouter} from "@athena-portal/components";
import {Types, IFalconPropositionEngine} from "@ferry/journey-services";
import {Navigate} from "react-router";
import {RetrieveQuoteFailureMessagePage} from "./RetrieveQuoteFailureMessagePage";
import {PluginTemplates} from "@ferry/plugin-ferry-journey";

interface IState {
    interaction?: any;
    match?: any;
    loadingInteraction?: boolean;
    tokenExpired?: boolean;
}

interface IParams {
    token: any;
    [key: string]: string | undefined;
}

export class RetrieveQuoteAndProceedPagePlain extends React.Component<IWithRouterProps<IParams>, IState> {

    @lazyInject(Types.FalconPropositionEngine)
    private propositionEngine: IFalconPropositionEngine;

    private pluginTemplates = new PluginTemplates();

    constructor(props: IWithRouterProps<IParams>) {
        super(props);
        this.state = {};
    }

    public componentDidMount() {
        this.pluginTemplates.setPageTitle("Quote retrieve and proceed");

        this.setState({loadingInteraction: true});

        const token = this.props.params.token;

        this.propositionEngine.fetchInteractionByToken(token).subscribe(
            (response: any) => {
                const interaction = response.response;
                this.setState({interaction, loadingInteraction: false});
            },
            (error: any) => {
                if (error.response && error.response.reason) {
                    this.setState({tokenExpired: error.response.reason === 'exp'});
                }
                this.setState({loadingInteraction: false});
            });
    }

    public render() {
        if (this.state.loadingInteraction) {
            return <Overlay show={true}/>
        }
        const {interaction} = this.state;
        const token = this.props.params.token;
        const decode = (str: string): string => Buffer.from(str, 'base64').toString('binary');
        const payload: string = token.split('.')[1];
        const product: string = JSON.parse(decode(payload)).product;

        if (interaction && interaction._id && product === "AnnualMotorInsurance") {
            return (
                <Navigate
                    to={`/journey/show/product/AnnualMotorInsurance/process/nb/summary/${interaction._id}`}/>
            );
        } else  if (interaction && interaction._id) {
            return (
                <Navigate
                    to={`/journey/show/product/MotorInsurance/process/nb/gdprPage/${interaction._id}`}/>
            );
        } else {
            let interactionId: string = "";
            if (this.state.tokenExpired) {
                interactionId = JSON.parse(decode(payload)).interactionId;
            }

            if (interactionId) {
                return (
                    <Navigate to={`/retrieveQuote?quote_id=${interactionId}`}/>
                );
            } else {
                return (
                    <RetrieveQuoteFailureMessagePage message="Quote not found, please enter details again..."/>
                );
            }

        }
    }
}

export const RetrieveQuoteAndProceedPage = withRouter<{}, IParams>(RetrieveQuoteAndProceedPagePlain)
